// prutl-frontend-npm6node14/src/pages/PassionFrameworkDimensionManagement.jsx

import React from 'react';
import PassionFrameworkDimensionList from '../components/passionFrameworkDimensionManagement/PassionFrameworkDimensionList.jsx';

const PassionFrameworkDimensionManagement = () => {
  return (
    <div className="passionFrameworkDimensionManagementContainer">
      <h1>Passion Framework Dimension Management</h1>
      <PassionFrameworkDimensionList />
    </div>
  );
};

export default PassionFrameworkDimensionManagement;
